import React, { useState } from 'react'
import StockList from './StockList'
import StockRoleAccessCard from './StockRoleAccessCard'
import useIsBlocked from 'src/hooks/useIsBlocked'
import PermissionBlockScreen from 'src/components/shared/PermissionBlockScreen'
import RolePermissionsModal from 'src/components/RolePermissionsModal'
import OllieNoticedRows from 'src/components/ollie/OllieNoticedRows'
import { OLLIE_NOTICED_PAGES } from 'src/utils/ollieNoticedRows'
import { STOCK_TAKE_MAIN_VS_PARTIAL_LINE } from 'src/utils/stockTakeCreateForm'

const StockScreen = () => {
  const blocked = useIsBlocked('stock')
  const [showRolePermissionsModal, setShowRolePermissionsModal] =
    useState(false)
  const stockFeatureHelperCopy = {
    heading: 'Main vs Partial',
    body: STOCK_TAKE_MAIN_VS_PARTIAL_LINE,
    tooltips: {
      linkedProducts:
        'Combine similar products from different suppliers into one stock count line. This only affects Stock Take and does not change your Catalogue.',
      conversions:
        'Count this item using a different unit, such as pints instead of kegs.',
      autoEmail:
        'Send the variance report automatically when this stock take is locked.',
    },
  }

  if (blocked) {
    return <PermissionBlockScreen />
  }

  const accessChrome = (
    <>
      <StockRoleAccessCard
        onViewAllPermissions={() => setShowRolePermissionsModal(true)}
      />
      <div
        data-testid='stock-main-vs-partial'
        style={{
          marginBottom: 12,
          padding: '10px 12px',
          border: '1px solid #e4efc8',
          background: '#f7fbec',
          borderRadius: 8,
          color: '#132d07',
          fontSize: 13,
        }}
      >
        <strong>{stockFeatureHelperCopy.heading}:</strong>{' '}
        {stockFeatureHelperCopy.body}
      </div>
    </>
  )

  return (
    <>
      <StockList
        ollieRow={<OllieNoticedRows page={OLLIE_NOTICED_PAGES.STOCK} />}
        accessChrome={accessChrome}
      />
      <RolePermissionsModal
        visible={showRolePermissionsModal}
        onCancel={() => setShowRolePermissionsModal(false)}
      />
    </>
  )
}

export default StockScreen
